export var SELECT = "Select";
export var RECORD_OPTIONS = 'RecordOptions';